import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "authConfig";
import axios from "axios";
import axiosInstance from "axiosintance";
import { getErrorMessageAndCode } from "getErrorFromResponse";


const TICKET_CUSTOM_FIELD_IDS = {
  name: 360007343594,
  phone: 360007135793,
  service: 360007135813,
  timeZone: 360029045834,
  severity: 360028555173,
  email: 360029033673,
};

const getCustomFieldValue = (customFields, fieldId) =>
  customFields?.find((field) => field?.id === fieldId)?.value ?? null;

export const setTicketinfo = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_BACKENDURL_SUPPORT}/ticket_detatil_show`,
      {
        ticketId: payload,
      }
    );

    const customFields = response?.data?.ticket?.custom_fields;

    return {
      id: response?.data?.ticket?.id,
      subject: response?.data?.ticket?.subject,
      time: response?.data?.ticket?.created_at,
      status: response?.data?.ticket?.status,
      requester_id: response?.data?.ticket?.requester_id,
      assignee_id: response?.data?.ticket?.assignee_id,
      name: getCustomFieldValue(customFields, TICKET_CUSTOM_FIELD_IDS.name),
      email: getCustomFieldValue(customFields, TICKET_CUSTOM_FIELD_IDS.email),
      phone: getCustomFieldValue(customFields, TICKET_CUSTOM_FIELD_IDS.phone),
      service: getCustomFieldValue(
        customFields,
        TICKET_CUSTOM_FIELD_IDS.service
      ),
      serverity: getCustomFieldValue(
        customFields,
        TICKET_CUSTOM_FIELD_IDS.severity
      ),
      timeZone: getCustomFieldValue(
        customFields,
        TICKET_CUSTOM_FIELD_IDS.timeZone
      ),
      casetype:
        response?.data?.ticket?.ticket_form_id == "360001970193"
          ? "Technical Problem"
          : " Custom Problem",
    };
  } catch (err) {
    let error = getErrorMessageAndCode(err);
    throw error;
  }
};
export const setTicketattachment = async (payload, updateProgress) => {
  try {
    const file = payload.target.files[0];

    const response = await axios.post(
      `${process.env.REACT_APP_ZENDESKURL}/api/v2/uploads?filename=${file.name}`,
      file,
      {
        headers: {
       
          "Content-Type": "application/binary",
        },
        onUploadProgress: (progress) => {
          const { loaded, total } = progress;
          const percentageProgress = Math.floor((loaded / total) * 99);
          updateProgress(percentageProgress);
        },
      }
    );

    return response.data.upload.token;
  } catch (err) {
    console.log(err);
    let error = getErrorMessageAndCode(err);
    throw error;
  }
};
export const Updatecommentdata = async (payload) => {
  try {
    const body1 = {
      ticket: {
        comment: {
          body: payload?.values?.messages,
          uploads: [`${payload?.Ticketattachment.data}`],
          author_id: payload?.Ticketinfo?.data?.requester_id,
        },
      },
    };
    const updatebodydata = new FormData();
    updatebodydata.append("body1", JSON.stringify(body1));
    updatebodydata.append("ticketId", payload?.ticketId);

    const response = await axiosInstance.post(
      `${process.env.REACT_APP_BACKENDURL_SUPPORT}/ticket_image`,
      updatebodydata
    );

    return response.data.ticket.updated_at;
  } catch (err) {
    console.log(err);
    let error = getErrorMessageAndCode(err);
    throw error;
  }
};
